import React from "react";
import ReactDOM from "react-dom";
import controller from "../../../../Resources/Scripts/_Shared/Controller";
import PmcNotificationListForm from "./PmcNotificationListForm";

function pmcNotificationList(context) {
  if (!context) return;
  let originalScrollPosition = 0;
  let isMounted = false;
  const openButton = context.previousElementSibling;

  const lockScroll = () => {
    originalScrollPosition = window.scrollY;
    document.documentElement.style.position = "fixed";
    document.documentElement.style.top = `-${originalScrollPosition}px`;
    document.documentElement.style.width = "100%";
  };

  const unlockScroll = () => {
    document.documentElement.style.removeProperty("position");
    document.documentElement.style.removeProperty("top");
    document.documentElement.style.removeProperty("width");
    window.scrollTo(0, originalScrollPosition);
  };

  const closePopup = () => {
    if (!isMounted) return;
    context.style.display = "none";
    unlockScroll();

    // Clean up React component
    const appContainer = context.querySelector("[data-app-container]");
    if (appContainer) {
      ReactDOM.unmountComponentAtNode(appContainer);
    }
    isMounted = false;
  };

  const handleDocumentClick = (e) => {
    if (e.target.closest(".facilitypage__notificationlist__close")) {
      closePopup();
    }
  };
  
  const onSubmit = () => {
    const description = context.querySelectorAll(".facilitypage__notificationlist__description_container");
    description[0].style.display = "none";
  }

  const handleKeyDown = (e) => {
    if (e.key === "Escape") closePopup();
  };

  const openPopup = () => {
    if (isMounted) return;
    context.style.display = "flex";
    // const htmlTags = document.getElementsByTagName("html")?.[0].style.overflow = "visible";
    
    lockScroll();

    // Render React component
    const appContainer = context.querySelector("[data-app-container]");
    if (appContainer) {
      const notificationListInner = context.querySelector(".facilitypage__notificationlist__inner");
      if(notificationListInner) {
        ReactDOM.render(
          <PmcNotificationListForm onSubmit={onSubmit} onSuccess={closePopup} pmcId={notificationListInner.getAttribute("data")}/>,
          appContainer
        );
        isMounted = true;
      }
    }
  };

  // Initialize event listeners
  openButton.addEventListener("click", openPopup);
  document.addEventListener("keydown", handleKeyDown);
  document.addEventListener("click", handleDocumentClick);

  // Cleanup function
  return {
    init: () => {},
    destroy: () => {
      openButton.removeEventListener("click", openPopup);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("click", handleDocumentClick);
      closePopup();
      unlockScroll();
    },
  };
}

controller.add("pmc-notificationlist", pmcNotificationList);
